import slice from "./savedLocationsSlice";

export default slice.reducer;
